<div class="tp-root"
     [class.tp-dark]="theme === 'dark'"
     [ngStyle]="rootVars">

  <!-- Selection highlight box — height tracks itemHeight via --tp-item-height -->
  <div class="tp-selection-box"></div>

  <div class="tp-columns">
    <!-- Hours column -->
    <tp-scroll-column
      [items]="hourItems"
      [selectedIndex]="hourIndex"
      [config]="mergedConfig"
      (selectedIndexChange)="onHourChange($event)"
      class="tp-col-number"
    ></tp-scroll-column>

    <!-- Colon separator -->
    <div class="tp-separator">:</div>

    <!-- Minutes column -->
    <tp-scroll-column
      [items]="minutes"
      [selectedIndex]="minuteIndex"
      [config]="mergedConfig"
      (selectedIndexChange)="onMinuteChange($event)"
      class="tp-col-number"
    ></tp-scroll-column>

    <!-- AM/PM column — only in 12h format -->
    <tp-scroll-column
      *ngIf="format === '12h'"
      [items]="periods"
      [selectedIndex]="periodIndex"
      [config]="mergedConfig"
      (selectedIndexChange)="onPeriodChange($event)"
      class="tp-col-period"
    ></tp-scroll-column>
  </div>
</div>
